export type ExpenseStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'HOLD';

export type ExpenseCategory =
  | 'RENT'
  | 'UTILITIES'
  | 'SALARIES'
  | 'MARKETING'
  | 'MAINTENANCE'
  | 'SUPPLIES'
  | 'TRANSPORT'
  | 'INSURANCE'
  | 'TAXES_FEES'
  | 'OTHER';

export type ApprovalType = 'EXPENSE' | 'DISCOUNT' | 'STOCK_TRANSFER' | 'RETURN' | 'VOID' | 'CREDIT' | 'WASTAGE';

export interface Expense {
  id: string;
  tenant_id: string;
  location_id: string;
  location_name: string;
  submitted_by_id: string;
  submitted_by_name: string;
  amount: number; // BIGINT paise
  category: ExpenseCategory;
  description: string;
  expense_date: string; // YYYY-MM-DD
  reference: string | null;
  receipt_url: string | null;
  status: ExpenseStatus;
  approved_by_id: string | null;
  approved_by_name: string | null;
  approved_at: string | null;
  rejection_reason: string | null;
  created_at: string;
  updated_at: string;
}

export interface ExpenseListSummary {
  total_amount: number; // paise
  pending_count: number;
  approved_count: number;
  rejected_count: number;
  hold_count: number;
}

export interface ExpenseListResponse {
  data: Expense[];
  meta: { total: number; page: number; limit: number };
  summary?: ExpenseListSummary;
}

export interface CreateExpensePayload {
  amount: number; // paise
  category: ExpenseCategory;
  description: string;
  expense_date: string;
  location_id: string;
  reference?: string;
  receipt_url?: string;
}

export interface ApprovalItem {
  id: string;
  type: ApprovalType;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  requested_by: string;
  requested_by_name: string | null;
  entity_type: string;
  entity_id: string | null;
  summary: string | null;
  amount: number | null; // paise
  location_id: string | null;
  location_name: string | null;
  created_at: string;
  updated_at?: string;
}

export interface ApprovalListResponse {
  data: ApprovalItem[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export const CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  RENT: 'Rent',
  UTILITIES: 'Utilities',
  SALARIES: 'Salaries',
  MARKETING: 'Marketing',
  MAINTENANCE: 'Maintenance',
  SUPPLIES: 'Supplies',
  TRANSPORT: 'Transport',
  INSURANCE: 'Insurance',
  TAXES_FEES: 'Taxes & Fees',
  OTHER: 'Other',
};

export const CATEGORY_OPTIONS = Object.entries(CATEGORY_LABELS).map(([value, label]) => ({
  value,
  label,
}));
